import { render, staticRenderFns } from "./UpdatePlantStructureForm.vue?vue&type=template&id=2d160ffa&"
import script from "./UpdatePlantStructureForm.vue?vue&type=script&lang=ts&"
export * from "./UpdatePlantStructureForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports